import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BoxesService } from '../boxes-service/boxes.service';
import { ListaBase } from '././../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from '././../../../../shared/gridview/EstruturaGridViewBuilder';

@Component({
  selector: 'app-boxes-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./boxes-lista.component.css']
})
export class BoxesListaComponent
 extends ListaBase
 implements OnInit {
 visualizarTotalRegistros: boolean;
 exibirBotaoDetalhes: boolean;

  constructor(service: BoxesService, toastr: ToastrService, router: Router) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 10;
    this.exibirBotaoDetalhes = true;
   }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna("nome_dealer", 'Dealer')
      .addColuna("ano", 'parametros.boxes.ano')
      .addColuna("mes", 'parametros.boxes.mes')
      .addColuna("valor", 'parametros.boxes.quantidade')
      .build();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.descricao;
  }

}
